import React from "react";

import { IgButton, IgTypography } from "@intelligems/ig-theme";
import { DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useAdjustBilling } from "@src/api/stripe/adjust-billing";
import { CloseIcon } from "@src/components/BillingPanel/components/ManageSubscriptionsDialog/Forms/CloseIcon";
import { ContentProps } from "@src/components/BillingPanel/components/ManageSubscriptionsDialog/types";

export const CancelContent = ({ setAction, handleClose }: ContentProps) => {
  const adjustBilling = useAdjustBilling();

  return (
    <>
      <DialogTitle sx={{ padding: "0 0 20px 0" }}>
        <IgTypography sx={{ fontSize: "18px" }}>
          Are You Sure You Want to Cancel?
        </IgTypography>
        <CloseIcon handleClose={handleClose} />
      </DialogTitle>
      <DialogContent sx={{ padding: "0 0 20px 0" }}>
        <IgTypography>
          Cancelling will result in losing all access to Intelligems including
          data from previous tests. Consider a pause plan to keep access to the
          platform while you’re not running tests.
        </IgTypography>
      </DialogContent>
      <DialogActions>
        <IgButton
          variant={"text"}
          onClick={() => setAction("cancelForm")}
          loading={adjustBilling.isPending}
        >
          Cancel Plan
        </IgButton>
        <IgButton variant={"contained"} onClick={() => setAction("pauseForm")}>
          Pause Plan
        </IgButton>
      </DialogActions>
    </>
  );
};
